import { render, staticRenderFns } from "./bo-radio.vue?vue&type=template&id=040b52dc"
import script from "./bo-radio.vue?vue&type=script&lang=js"
export * from "./bo-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports